var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraw2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "url(#draw2_svg__paint0_linear_1_3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M29 26a7.994 7.994 0 01-8 8 8 8 0 118-8z",
    stroke: "#fff",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    clipRule: "evenodd",
    d: "M37 26a8 8 0 01-12 6.928A7.994 7.994 0 0029 26a7.994 7.994 0 00-4-6.93A8 8 0 0137 26z",
    stroke: "#fff",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 26a7.994 7.994 0 01-4 6.928A7.994 7.994 0 0121 26a7.994 7.994 0 014-6.93A7.994 7.994 0 0129 26",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "draw2_svg__paint0_linear_1_3",
    x1: -23.105,
    y1: 25.632,
    x2: 25.632,
    y2: 74.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505FFF"
  })))));
}
export default SvgDraw2;